export default __webpack_public_path__ + "static/media/alltribes_for_loading.6239ad37.gif";